<template>
  <b-container>
    
    <div v-if="topics.length > 0 || unMatchedItems.length > 0" class="d-flex align-items-center justify-content-between row mt-2">
      <h3 class="m-0">Detail View</h3>
      <b-btn-group>
          <b-btn variant="outline-secondary" size="sm" @click="openConceptsModal">
            <i class="fa fa-plus" /> Add concepts
          </b-btn>
          <!--<b-btn  v-if="topics.length > 0" variant="outline-secondary" size="sm" @click="saveBlock">
            <i class="fa fa-save" /> Save
          </b-btn>-->
          <b-btn variant="outline-secondary" size="sm" @click="closeDetail">
            <i class="fa fa-times" /> Close
          </b-btn>
        </b-btn-group>
    </div>

    <b-row v-if="topics.length > 0" class="my-2 dropzone halfHeight" :class="{ 'fullHeight':layout }">
      <b-col>
        <draggable
          :list="ttcDropped"
          :group="{ name: 'annotations', pull: false, put: true }"
          :sort="false"
          class="dropzone-inner"
          draggable=".drag"
          @change="dropzoneFetch"
        >
          <div
            v-for="topic in topics"
            :key="topic.id"
            class="topic"
            :style="'border-top-color:' + topic.colors[ttcColorMetric].bg"
          >
            <b-row class="mb-2">
              <b-col class="title small">
                <i class="fa fa-book-open mr-1"></i>
                Topic
              </b-col>
              <b-col class="text-right">
                <b-btn
                  size="sm"
                  variant="link-dark"
                  class="p-0 right"
                  @click="removeTopic(topic)"
                >
                  <i class="fa fa-times-circle" />
                </b-btn>
              </b-col>
            </b-row>
            <div v-for="theme in topic.children" :key="theme.id">
              <b-row class="mb-2">
                <b-col>
                  <b-badge
                    v-for="concept in theme.children"
                    :key="concept.id"
                    class="mr-1 cursor-pointer"
                    :class="{ 'badge-unchecked': !concept.checked }"
                    :style="
                      'background-color:' +
                        concept.colors[ttcColorMetric].bg +
                        '; color:' +
                        concept.colors[ttcColorMetric].text
                    "
                    @click="toggleConceptCheck(concept)"
                  >
                    {{ concept.name }}
                  </b-badge>
                </b-col>
                <b-col cols="2" class="text-right">
                  <b-btn
                    size="sm"
                    variant="link-dark"
                    class="p-0"
                    @click="uncheckTheme(theme)"
                  >
                    <i class="fa fa-minus-circle" />
                  </b-btn>
                  <b-btn
                    size="sm"
                    variant="link-dark"
                    class="p-0"
                    @click="checkTheme(theme)"
                  >
                    <i class="fa fa-plus-circle" />
                  </b-btn>
                </b-col>
              </b-row>
            </div>
          </div>
        </draggable>
      </b-col>
    </b-row>
    <b-overlay :show="show" rounded="sm">
      <b-row class="mt-2 pt-2 pb-2 card" v-if="unMatchedItems.length > 0">
        <b-col>
          <h3>Unmatched Concepts (Click to find similar concepts)</h3>
          <b-badge v-for="item, n in unMatchedItems" :key="n" variant="light" class="mr-1 cursor-pointer" @click="searchItems(item)">{{ item }}</b-badge>
        </b-col>
      </b-row>
    </b-overlay>

    <FilterItemModal
      :create="true"
      :filter="modalFilter"
      title="Create filter"
    ></FilterItemModal>

    <b-modal
      id="modal-concepts"
      centered
      title="Add concepts"
      :no-close-on-backdrop="true"
    >
      <b-form-group
        id="input-group-search"
        label="Search"
        label-for="input-search"
      >
        <b-form-input
          id="input-search"
          v-model.trim="form.search"
          v-validate="{ required: true, max: 100 }"
          type="text"
          placeholder="Search"
          size="lg"
          data-vv-name="search"
          autofocus
          @keyup.enter="submitConceptsModal"
        ></b-form-input>
      </b-form-group>
      <template slot="modal-footer">
        <b-btn
          variant="primary"
          class="float-right"
          @click="submitConceptsModal"
        >
          <i class="fa fa-search" /> Search
        </b-btn>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import _ from "lodash";
import draggable from "vuedraggable";
import { mapActions, mapGetters, mapState } from "vuex";
import { EventBus } from "@/eventBus";
import FilterItemModal from "./FilterItemModal";

export default {
  name: "Annotations",
  components: {
    FilterItemModal,
    draggable
  },
  props: {
    layout: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      form: {
        search: null
      },
      ttcLocal: null,
      ttcDropped: [],
      topics: [],
      selection: [],
      unMatchedItems: [],
      show: false
    };
  },
  computed: {
    ...mapGetters(["ttcLookup"]),
    ...mapState({
      ttc: state => state.ttc.ttc,
      ttcColorMetric: state => state.ttc.ttcColorMetric
    }),
    query() {
      let query = [];

      // Put checked concepts in flat array
      this.topics.forEach(topic => {
        topic.children.forEach(theme => {
          let checkedConcepts = theme.children.filter(c => c.checked === true);
          if (checkedConcepts.length) {
            let nodes = checkedConcepts.map(c => {
              return { _id: c.id };
            });
            query.push(...nodes);
          }
        });
      });

      // Put 'OR' between each of the concepts
      query = query.flatMap((value, index, array) =>
        array.length - 1 !== index ? [value, "OR"] : value
      );

      return query;
    },
    modalFilter() {
      return {
        query: this.query
      };
    }
  },
  watch: {
    checkedConcepts(val) {
      this.loadDocuments({
        page: 1,
        pageSize: 10, // TODO: Load from store
        sortOn: "pubdate",
        sortAsc: false,
        search: null,
        ttc: val
      });
    }
  },
  mounted() {
    this.ttcLocal = JSON.parse(JSON.stringify(this.ttc));
    EventBus.$on("showDetail", element => {
      this.dropzoneChange(element);
    });
  },
  methods: {
    ...mapActions(["loadDocuments", "saveFilter", "searchTTCConcepts"]),
    initAsFresh(){

    },
    dropzoneChange(e) {
      let el = e;
      let found = false;
      let index = 0;
      if (e) {
        if (_.isArray(el.value)) {
          _.each(el.value, item => {
            _.each(this.ttcLocal, topic => {
              _.each(topic.children, theme => {
                _.each(theme.children, concept => {
                  if (concept.id === item) {
                    found = true;
                    if (!this.topics.includes(topic)) {
                      // Mark dragged concept as checked
                      concept.checked = true;
                      this.topics.push(topic);
                    } else {
                      // If dragged concept is already present, make sure it's checked
                      concept.checked = true;
                    }
                  }
                });
              });
            });
            //let concept = this.ttcLookup({ id: item });
            //let topic = this.ttcLookup({ id: concept.topic_id });
            //concept.checked = true;
            //this.topics.push(topic);
            if(!found){
              this.unMatchedItems.push(el.info[index]);
              index += 1;
            }
            else{
              found = false;
              index += 1;
            }
          });
        } else {
          let topic = this.ttcLocal.find(topic => topic.id === el.topic);

          if (!this.topics.includes(topic)) {
            // Mark dragged concept as checked
            let theme = topic.children.find(theme => theme.id === el.theme);
            let concept = theme.children.find(
              concept => concept.id === el.value
            );
            concept.checked = true;
            this.topics.push(topic);
          } else {
            // If dragged concept is already present, make sure it's checked
            let theme = topic.children.find(theme => theme.id === el.theme);
            let concept = theme.children.find(
              concept => concept.id === el.value
            );
            concept.checked = true;
          }
        }
      }
    },
    dropzoneFetch(e) {
      let el = e.added.element;
      if (e) {
        if (el.type === "topic") {
          let topic = this.ttcLocal.find(topic => topic.id === el.id);

          if (!this.topics.includes(topic)) {
            // Mark dragged topic's concepts as checked
            topic.children.forEach(theme => {
              theme.children.forEach(concept => (concept.checked = true));
            });
            this.topics.push(topic);
          } else {
            // If dragged topic is already present, make sure its children are checked
            let topic = this.ttcLocal.find(topic => topic.id === el.id);
            topic.children.forEach(theme => {
              theme.children.forEach(concept => (concept.checked = true));
            });
          }
        }
        if (el.type === "theme") {
          let topic = this.ttcLocal.find(topic => topic.id === el.topic_id);

          if (!this.topics.includes(topic)) {
            // Mark dragged theme's concepts as checked
            let theme = topic.children.find(theme => theme.id === el.id);
            theme.children.forEach(concept => (concept.checked = true));
            this.topics.push(topic);
          } else {
            // If dragged theme is already present, make sure its children are checked
            let theme = topic.children.find(theme => theme.id === el.id);
            theme.children.forEach(concept => (concept.checked = true));
          }
        }
        if (el.type === "concept") {
          let topic = this.ttcLocal.find(topic => topic.id === el.topic_id);

          if (!this.topics.includes(topic)) {
            // Mark dragged concept as checked
            let theme = topic.children.find(theme => theme.id === el.theme_id);
            let concept = theme.children.find(concept => concept.id === el.id);
            concept.checked = true;
            this.topics.push(topic);
          } else {
            // If dragged concept is already present, make sure it's checked
            let theme = topic.children.find(theme => theme.id === el.theme_id);
            let concept = theme.children.find(concept => concept.id === el.id);
            concept.checked = true;
          }
        }
      }
    },
    closeDetail() {
      EventBus.$emit("toggleBuilder", "close");
      this.$emit("editBlock", this.topics);
      this.topics.forEach(item => {
        item.children.forEach(theme =>
          theme.children.forEach(concept => (concept.checked = false))
        );
      });
      this.topics = [];
      this.unMatchedItems = [];
    },
    updateBlock() {
      this.$emit("editBlock", this.topics);
    },
    saveBlock() {
      this.$emit("editBlock", this.topics);
      EventBus.$emit("toggleBuilder", "close");
      this.topics = [];
      this.unMatchedItems = [];
    },
    toggleConceptCheck(c) {
      c.checked = !c.checked;
      this.updateBlock();
    },
    uncheckTopic(item) {
      let topic = this.ttcLookup({ id: item.topic_id });
      topic.children.forEach(theme =>
        theme.children.forEach(concept => (concept.checked = false))
      );
    },
    checkTheme(theme) {
      theme.children.forEach(concept => (concept.checked = true));
      this.updateBlock();
    },
    uncheckTheme(theme) {
      theme.children.forEach(concept => (concept.checked = false));
      this.updateBlock();
    },
    removeTopic(topic) {
      topic.children.forEach(theme =>
        theme.children.forEach(concept => (concept.checked = false))
      );
      let i = _.findIndex(this.topics, t => t.id === topic.id);
      this.topics.splice(i, 1);
      if (this.topics.length < 1) {
        this.saveBlock();
      }
    },
    openFilterModal() {
      this.$bvModal.show("modal-filter-create");
    },
    openConceptsModal() {
      this.$bvModal.show("modal-concepts");
    },
    submitConceptsModal() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$toasted.show(this.$validator.errors.items[0].msg, {
            type: "error"
          });
          return;
        }

        this.searchTTCConcepts({ query: this.form.search }).then(res => {
          res.forEach(c => {
            //const topic = this.ttcLookup({ id: c.topic_id });
            const topic = this.ttcLocal.find(topic => topic.id === c.topic_id);
            const theme = topic.children.find(theme => theme.id === c.theme_id);
            const concept = theme.children.find(concept => concept.id === c.id);

            // Only add topic if it's not already added
            if (!this.topics.includes(topic)) {
              this.topics.push(topic);
            }

            // Check concept
            concept.checked = true;
          });

          this.$bvModal.hide("modal-concepts");
          this.form.search = null;
        });
      });
    },
    async searchItems(item) {
      let words = item.split(" ");
      let count = 0;
      let matches = 0;
      this.show = true;
        words.forEach(word => {    
          this.searchTTCConcepts({ query: word }).then(result => {
              if(result.length > 0){
                let mcount = 0;
                result.forEach(c => {
                  //const topic = this.ttcLookup({ id: c.topic_id });
                  const topic = this.ttcLocal.find(topic => topic.id === c.topic_id);
                  const theme = topic.children.find(theme => theme.id === c.theme_id);
                  const concept = theme.children.find(concept => concept.id === c.id);

                  // Only add topic if it's not already added
                  if (!this.topics.includes(topic)) {
                    this.topics.push(topic);
                  }

                  // Check concept
                  concept.checked = true;
                  mcount += 1;
                  if(result.length === mcount){
                    matches += mcount;
                    count += 1;
                    if(words.length === count){
                      this.$toasted.show("Found "+matches+" Topics with matching concept", {
                        type: "success"
                      });
                      this.show = false;
                    }
                  }
                });
              }
              else{
                count += 1;
                if(words.length === count){
                  this.$toasted.show("Found "+matches+" Topics with matching concept", {
                    type: "success"
                  });
                  this.show = false;
                }
              }
          });
        });
    }
  }
};
</script>
